import { Component } from '@angular/core';

@Component({
  templateUrl: 'model-read-settings-dialog.component.html',
})
export class ModelReadSettingsDialogComponent {
  checkAssembly = false;
  checkFurniture = false;

  constructor() {}
}
